import { render, staticRenderFns } from "./WrsViNumeric.vue?vue&type=template&id=7c53a484&"
import script from "./WrsViNumeric.vue?vue&type=script&lang=js&"
export * from "./WrsViNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports